import { type OptInType, type ResourceId, type UserDataKey } from '../common/structs';

export const user = () => ({
    current: () => `/account`,
    primaryYat: () => `/account/yat`,
    collection: () => `/users`,
    load: () => `/account/load`,
    single: (id: ResourceId) => `/users/${id}`,
    username: () => `/account/username`,
    twoFactorAuth: () => ({
        enable: () => `/account/2fa/enable`,
        confirm: () => `/account/2fa/confirm`,
        disable: () => `/account/2fa/disable`,
        sendSms: () => `/account/2fa/sms_code`,
    }),
    data: (key: UserDataKey) => `/user/data/${key}`,
    consume: (userId: ResourceId) => `/users/${userId}/orders/consume`,
    orders: () => `/my/orders`,
    discordData: () => '/user/data/DiscordData',
    waitlistSize: (waitlistType: string) => `/account/waitlist/${waitlistType}/size`,
    waitlistPlace: (waitlistType: string) => `/account/waitlist/${waitlistType}/place`,
    waitlist: (waitlistType: string) => `/account/waitlist/${waitlistType}`,
    optIn: (optInType: OptInType) => `/opt_ins/${optInType}`,
    twitterData: () => '/user/data/TwitterData',
    public: (id: ResourceId) => `/users/${id}/public`,
});
